import { createFileRoute } from '@tanstack/react-router'
import { FraudAnalysisUnlockPage } from 'features/fraudAnalysis'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/fraud-analysis/unlock')({
  component: FraudAnalysisUnlockPage,
})
